/*
Auto-generated by: https://github.com/pmndrs/gltfjsx used https://gltf.pmnd.rs/
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useTexture, useAnimations } from "@react-three/drei";

import useControlAnimal from "../hooks/useControlAnimal";
import useFlight from "../hooks/useFlight";
import useUpdateAnimal from "../hooks/useUpdateAnimal";
import useEndGame from "../hooks/useEndGame";

export default function Rabbit({}) {

    const [
        fur,
        eye,
    ] = useTexture([
        '/textures/smart_uv_white_black2_reduced.png',
        '/textures/eye_reduced.png',
    ])

    const animalRef = useRef();
    const animalName = 'rabbit';
    const actionName = 'run';
    const otherAnimalName = 'fox';

    const { nodes, materials, animations } = useGLTF("/objects/hase_098.glb");
    const { actions } = useAnimations(animations, animalRef);

    useControlAnimal(animalName, actionName, actions);
    useFlight(animalName, actionName, actions);
    useUpdateAnimal(animalRef, animalName, actions);
    useEndGame(animalName, actionName, otherAnimalName, actions);

    return (
        <group ref={animalRef} dispose={null}>
            <group name="Scene">
                <group name="rabbit_rig" scale={0.25} position={[0, -2, 0]}>
                    <primitive object={nodes.root} />
                    <group name="rabbit">
                        <skinnedMesh
                            name="Cube"
                            geometry={nodes.Cube.geometry}
                            material={materials.pupil}
                            skeleton={nodes.Cube.skeleton}
                        />
                        <skinnedMesh
                            name="Cube_1"
                            geometry={nodes.Cube_1.geometry}
                            material={materials.eye}
                            skeleton={nodes.Cube_1.skeleton}
                        >
                            <meshStandardMaterial map={eye} map-flipY={false} attachArray="material" />
                        </skinnedMesh>
                        <skinnedMesh
                            name="Cube_2"
                            geometry={nodes.Cube_2.geometry}
                            material={materials.eye_back}
                            skeleton={nodes.Cube_2.skeleton}
                        >
                            <meshStandardMaterial map={eye} map-flipY={false} attachArray="material" />
                        </skinnedMesh>
                        <skinnedMesh
                            name="Cube_3"
                            geometry={nodes.Cube_3.geometry}
                            material={materials.all}
                            skeleton={nodes.Cube_3.skeleton}
                        >
                            <meshStandardMaterial map={fur} map-flipY={false} attachArray="material" />
                        </skinnedMesh>
                    </group>
                </group>
            </group>
        </group>
    );
}

useGLTF.preload("/hase_097.glb");
